module.exports = __webpack_public_path__ + "static/media/collision_box.fragment.73694e80.glsl";